import { takeEvery, call, put, select } from 'typed-redux-saga'
import { errorHandler, notifyMessageCreator, gridSlice } from 'Modules'
import { Deserialize } from 'cerialize'
import { ResponseCatalog, RequestParams } from 'Models'
import {
	BlacklistModel,
	SourceModel,
	blackListApi,
	BlacklistNS,
	blacklistSlice,
	blacklistSelectors,
} from 'Pages/coliseum'

function* getAll(action: BlacklistNS.GetAll) {
	try {
		yield* put(gridSlice.actions.setLoading(true))
		const { params, clear } = action.payload
		const { page, per_page, query, ...fields } = params
		const requestParams = new RequestParams(clear ? 1 : page, per_page, query, fields)
		if (clear) {
			yield* put(blacklistSlice.actions.clearAll())
		}
		const data = yield* call(blackListApi.getAll, requestParams)
		const blacklists = new ResponseCatalog<BlacklistModel>(data)
		if (!clear) {
			const oldData = yield* select(blacklistSelectors.getAll)
			blacklists.entries = oldData.concat(data.entries)
		}
		yield* put(blacklistSlice.actions.setAll(blacklists))
		yield* put(blacklistSlice.actions.setRequestParams(requestParams))
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(gridSlice.actions.setLoading(false))
	}
}

function* createOne(action: BlacklistNS.CreateOne) {
	try {
		yield* call(blackListApi.createOne, action.payload)
		yield* put(blacklistSlice.actions.getAll({ params: new RequestParams(), clear: true }))
		yield* call(notifyMessageCreator, 'coliseum.blacklist_create.success')
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

function* massloadAll(action: BlacklistNS.MassloadAll) {
	try {
		const { file } = action.payload
		yield* call(blackListApi.massloadAll, file)
		const res = yield* call(blackListApi.getAll)
		const blacklists = new ResponseCatalog<BlacklistModel>(res)
		yield* put(blacklistSlice.actions.setAll(blacklists))
		yield* call(notifyMessageCreator, 'coliseum.blacklist_massload.success')
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

function* getAllSource() {
	try {
		const res = yield* call(blackListApi.getAllSource)
		const sources = res.map((source): SourceModel => Deserialize(source, SourceModel))
		yield* put(blacklistSlice.actions.setAllSource(sources))
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

export function* blacklistSaga() {
	yield* takeEvery(blacklistSlice.actions.getAll, getAll)
	yield* takeEvery(blacklistSlice.actions.createOne, createOne)
	yield* takeEvery(blacklistSlice.actions.massloadAll, massloadAll)
	yield* takeEvery(blacklistSlice.actions.getAllSource, getAllSource)
}
